import { axiosInstance } from '../axios';

const API_URL = '/api/services';

class ServiceService {
  async list(params) {
    let queryParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
      if (value === null || value === undefined){
        continue;
      }
      queryParams.append(key, value);
    }
    return axiosInstance.get(
        `${API_URL}/list`,
        {
          params: queryParams,
        },
    );
  }

  async get(serviceIdId) {
    return axiosInstance.get(
        `${API_URL}/get/${serviceIdId}`,
    );
  }


  async getPrefilledForDefectReport(defectReportId) {
    let queryParams = new URLSearchParams();
    queryParams.append('defectReportId', defectReportId);
    return axiosInstance.get(
        `${API_URL}/get-prefilled-for-adding`,
        {
          params: queryParams,
        },
    );
  }

  async getPrefilledForPlannedServiceInstance(plannedServiceInstanceId) {
    let queryParams = new URLSearchParams();
    queryParams.append('plannedServiceInstanceId', plannedServiceInstanceId);
    return axiosInstance.get(
        `${API_URL}/get-prefilled-for-adding`,
        {
          params: queryParams,
        },
    );
  }

  async save(serviceDTO) {
    return axiosInstance.post(API_URL + '/save', serviceDTO);
  }

  async saveQuickPartUseService(quickPartUseServiceDTO) {
    return axiosInstance.post(
        `${API_URL}/save-quick-part-use-service`,
        quickPartUseServiceDTO,
    );
  }

  async delete(serviceIds) {
    let data = new FormData();
    serviceIds.forEach(id => data.append('ids', id) );
    return axiosInstance.delete(
        `${API_URL}/delete`,
        { data:data },
    );
  }
}

export default new ServiceService();
